import type { SVGProps } from "react";

export const PointClickIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" fill="none" {...props}>
			<g
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				clipPath="url(#a)"
			>
				<path d="m15 24-1 1M20 12v2M14 14l1 2M12 20h2M25 14l-1 2M9 27H8a4 4 0 0 1-4-4V8a4 4 0 0 1 4-4h15a4 4 0 0 1 4 4v2M22 29l-3-9a1 1 0 0 1 0-1l10 3a1 1 0 0 1 0 1l-4 2-2 4a1 1 0 0 1-1 0Z" />
			</g>
			<defs>
				<clipPath id="a">
					<path fill="#fff" d="M0 0h32v32H0z" />
				</clipPath>
			</defs>
		</svg>
	);
};

export const CouponDiscountIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" {...props}>
			<g
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				clipPath="url(#a)"
			>
				<path d="m15.9 16.5.7-.8M11.4 20.9l-.7.7M10.7 19c-.1.6 0 1.1.4 1.5l.3.4.5.4a1.5 1.5 0 0 0 2.3-1.8l-1-1.7a1.5 1.5 0 0 1 2.2-1.8l.5.5.3.3c.4.4.5 1 .4 1.5M21 11.2a.5.5 0 1 1-.6.7.5.5 0 0 1 .7-.7Z" />
				<path d="M18 5.7H24c1.5 0 2.8 1.2 2.8 2.8v5.8c0 .7-.3 1.5-.9 2L14.6 27.5c-1 1-2.8 1-4 0l-5.8-5.8c-1-1.1-1-3 0-4L16 6.5c.6-.6 1.3-.8 2-.8Z" />
			</g>
			<defs>
				<clipPath id="a">
					<path fill="#fff" d="M0 .3h32v32H0z" />
				</clipPath>
			</defs>
		</svg>
	);
};

export const GlobeMinusIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" {...props}>
			<g
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				clipPath="url(#a)"
			>
				<path strokeMiterlimit="10" d="M16 28.32a12 12 0 1 1 12-12m-23.32-4h22.55m-22.54 8H16" />
				<path
					strokeMiterlimit="10"
					d="M21.33 16.32c0-3.69-.96-7.37-2.89-10.59a2.82 2.82 0 0 0-4.88 0 20.84 20.84 0 0 0 0 21.18c.56.94 1.5 1.41 2.44 1.41"
				/>
				<path d="M24 30.99c3.67 0 6.67-3 6.67-6.67 0-3.66-3-6.67-6.67-6.67s-6.67 3-6.67 6.67A6.66 6.66 0 0 0 24 31Zm0-9.39v-.61m0 6.06v.6" />
				<path d="M22.42 26.4c.24.38.64.65 1.13.65h.99a1.28 1.28 0 0 0 .31-2.52l-1.7-.42a1.28 1.28 0 0 1 .3-2.52h1c.49 0 .9.27 1.13.65" />
			</g>
			<defs>
				<clipPath id="a">
					<path fill="#fff" d="M0 .32h32v32H0z" />
				</clipPath>
			</defs>
		</svg>
	);
};

export const InteraceEssentialIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" {...props}>
			<g stroke="#635BFF" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" clipPath="url(#a)">
				<path d="m24.5 7.5-17 17M16 28a12 12 0 1 1 12-12m-4.3 3.3-2 6.7m5.6-5.3 2 2m0 0-2 2" />
				<path d="m18 20.7-2 2 2 2" />
			</g>
			<defs>
				<clipPath id="a">
					<path fill="#fff" d="M0 0h32v32H0z" />
				</clipPath>
			</defs>
		</svg>
	);
};

export const CheckboxIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" {...props}>
			<g stroke="#635BFF" strokeWidth="2" clipPath="url(#a)">
				<path strokeLinecap="round" strokeLinejoin="round" d="m11.04 22.81-2.96 2.97L6.3 24" />
				<path
					strokeLinecap="round"
					strokeLinejoin="round"
					d="M11.33 29.33H6a2.67 2.67 0 0 1-2.67-2.66v-5.34c0-1.47 1.2-2.66 2.67-2.66h5.33A2.66 2.66 0 0 1 14 21.33v5.34c0 1.47-1.2 2.66-2.67 2.66Z"
				/>
				<path d="M23.33 29.33A5.33 5.33 0 0 1 18 24a5.41 5.41 0 0 1 5.34-5.33 5.33 5.33 0 0 1 0 10.66Z" />
				<path
					strokeLinecap="round"
					strokeLinejoin="round"
					d="M23.56 24.23a.33.33 0 1 0-.46 0c.13.13.34.13.46 0ZM12 6.67H9.33a2 2 0 0 0 0 4H12a2 2 0 0 0 0-4Z"
				/>
				<path
					strokeLinecap="round"
					strokeLinejoin="round"
					d="M9.33 2.67h13.34a6 6 0 0 1 0 12H9.33a6 6 0 0 1 0-12Z"
				/>
			</g>
			<defs>
				<clipPath id="a">
					<path fill="#fff" d="M0 0h32v32H0z" />
				</clipPath>
			</defs>
		</svg>
	);
};

export const CursorSettingEditFilterIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" {...props}>
			<g stroke="#635BFF" strokeWidth="2">
				<path
					strokeLinecap="round"
					strokeLinejoin="round"
					d="M17.111 24h-5.566l-3.566 3.535c-.98.972-2.645.277-2.645-1.103v-14.21c0-1.382 1.672-2.075 2.65-1.097L18.21 21.351c.977.977.285 2.649-1.099 2.649Z"
				/>
				<path d="M22.66 16a6.667 6.667 0 0 1-6.666-6.667c0-3.605 3.067-6.669 6.672-6.666A6.666 6.666 0 0 1 22.661 16Z" />
				<path
					strokeLinecap="round"
					strokeLinejoin="round"
					d="M22.662 6.37v.993m0 3.941v.992M20.1 7.852l.858.49m3.422 1.983.845.49m-5.125 0 .858-.49m3.422-1.984.845-.489m-1.165.084a1.976 1.976 0 1 1-2.794 2.795 1.976 1.976 0 0 1 2.793-2.795Z"
				/>
			</g>
		</svg>
	);
};

export const AppStarIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" {...props}>
			<path
				stroke="#635BFF"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M21 12v3.3c0 3.1-2.5 5.7-5.7 5.7H8.7A5.7 5.7 0 0 1 3 15.3V8.7C3 5.5 5.5 3 8.7 3H12m5.5-1c0 2.5 2 4.5 4.5 4.5"
			/>
			<path
				stroke="#635BFF"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M22 6.5c-2.5 0-4.5 2-4.5 4.5m0 0c0-2.5-2-4.5-4.5-4.5m0 0c2.5 0 4.5-2 4.5-4.5"
			/>
		</svg>
	);
};

export const ProgrammingDataIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" {...props}>
			<g
				stroke="#635BFF"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeMiterlimit="10"
				strokeWidth="2"
				clipPath="url(#a)"
			>
				<path d="M6.5 5.25a2.25 2.25 0 1 0-4.5 0 2.25 2.25 0 0 0 4.5 0Zm7.75 0a2.25 2.25 0 1 0-4.5 0 2.25 2.25 0 0 0 4.5 0Zm0 13.5a2.25 2.25 0 1 0-4.5 0 2.25 2.25 0 0 0 4.5 0ZM22 5.25a2.25 2.25 0 1 0-4.5 0 2.25 2.25 0 0 0 4.5 0Z" />
				<path d="M4.25 7.5V10c0 1.1.9 2 2 2h11.5a2 2 0 0 0 2-2V7.5M12 7.5v9" />
			</g>
			<defs>
				<clipPath id="a">
					<path fill="#fff" d="M0 0h24v24H0z" />
				</clipPath>
			</defs>
		</svg>
	);
};

export const ButtonIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg width="42" height="43" viewBox="0 0 42 43" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<rect width="42" height="43" rx="21" fill="#E6E6E6" />
			<mask id="path-2-inside-1_1106_710" fill="white">
				<path d="M1 21C1 9.95431 9.95431 1 21 1C32.0457 1 41 9.95431 41 21C41 32.0457 32.0457 41 21 41C9.95431 41 1 32.0457 1 21Z" />
			</mask>
			<path
				d="M1 21C1 9.95431 9.95431 1 21 1C32.0457 1 41 9.95431 41 21C41 32.0457 32.0457 41 21 41C9.95431 41 1 32.0457 1 21Z"
				fill="url(#paint0_linear_1106_710)"
			/>
			<path
				d="M0 20.5C0 9.17816 9.17816 0 20.5 0H21.5C32.8218 0 42 9.17816 42 20.5L40 21C40 10.5066 31.4934 2 21 2C10.5066 2 2 10.5066 2 21L0 20.5ZM41 41H1H41ZM20.5 41C9.17816 41 0 31.8218 0 20.5C0 9.17816 9.17816 0 20.5 0L21 2C10.5066 2 2 10.5066 2 21C2 32.0457 10.5066 41 21 41H20.5ZM21.5 0C32.8218 0 42 9.17816 42 20.5C42 31.8218 32.8218 41 21.5 41H21C31.4934 41 40 32.0457 40 21C40 10.5066 31.4934 2 21 2L21.5 0Z"
				fill="#FAFAFA"
				mask="url(#path-2-inside-1_1106_710)"
			/>
			<g clipPath="url(#clip0_1106_710)">
				<path d="M21 14V28" stroke="#3F3F3F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
				<path
					d="M28 21L14 21"
					stroke="#3F3F3F"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<linearGradient
					id="paint0_linear_1106_710"
					x1="21"
					y1="1"
					x2="21"
					y2="41"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#EDEDED" />
					<stop offset="1" stopColor="#FAFAFA" />
				</linearGradient>
				<clipPath id="clip0_1106_710">
					<rect width="24" height="24" fill="white" transform="translate(9 9)" />
				</clipPath>
			</defs>
		</svg>
	);
};

export const HamburgerIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" fill="none" {...props}>
			<path
				stroke="#000"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.5"
				d="M7 8.5h10m-10 4h10m-10 4h10"
			/>
		</svg>
	);
};

export const XIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" fill="none" {...props}>
			<path
				stroke="#000"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.5"
				d="m17 7.5-10 10m0-10 10 10"
			/>
		</svg>
	);
};
